<template>
  <div v-if="visible" class="sb-notification--dot">
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
  },
};
</script>
<style scoped>
.sb-notification--dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #fff;
  background-color: #e53e3e;
  position: absolute;
  top: -5px;
  right: -5px;
  transition: all 200ms ease-out;
  animation: blink 2s linear infinite;
}
@keyframes blink {
  0% {
    filter: brightness(100%);
  }
  50% {
    filter: brightness(150%);
  }
  100% {
    filter: brightness(100%);
  }
}
</style>
